module.exports = __webpack_public_path__ + "static/media/limit-error.860ac688.svg";